import axios from "axios";

/**
 * Backend base URL is set to your API.
 * If you deploy the frontend on the same domain later, you can change this to "/".
 */
const axiosInstance = axios.create({
  baseURL: "https://api.rashtechinfo.com",
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;
